/**
 * Copy of `value` with object keys sorted and arrays of primitives sorted, so
 * two structurally-equal values stringify identically regardless of insertion
 * order (arrays of objects keep their order - it usually carries meaning).
 */
export function sortDeepForComparison<T>(value: T): T {
  if (Array.isArray(value)) {
    const items = value.map((item) => sortDeepForComparison(item));
    return (
      items.every((item) => item === null || typeof item !== 'object')
        ? [...items].sort((a, b) => String(a).localeCompare(String(b)))
        : items
    ) as T;
  }
  if (value && typeof value === 'object') {
    return Object.keys(value as object)
      .sort()
      .reduce(
        (acc, key) => {
          acc[key] = sortDeepForComparison((value as any)[key]);
          return acc;
        },
        {} as Record<string, unknown>,
      ) as T;
  }
  return value;
}
